<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';
  import { cn } from '@/lib/utils';

  interface SkeletonTitleProps {
    class?: HTMLAttributes['class'];
  }

  const props = defineProps<SkeletonTitleProps>();
</script>

<template>
  <div
    :class="
      cn('animate-pulse rounded-xl bg-zinc-300 dark:bg-zinc-800', props.class)
    " />
</template>
